import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 17.5c1.872 0 3.668-.79 4.991-2.197C16.315 13.897 17.06 11.99 17.06 10c0-1.99-.744-3.897-2.068-5.303C13.668 3.29 11.872 2.5 10 2.5s-3.668.79-4.991 2.197C3.685 6.103 2.94 8.01 2.94 10c0 1.99.744 3.897 2.068 5.303C6.332 16.71 8.128 17.5 10 17.5M7.623 7.343c.218-.654.803-1.093 1.456-1.093h1.608c.962 0 1.74.83 1.74 1.849 0 .662-.334 1.274-.875 1.605l-.89.542c-.006.381-.3.691-.662.691-.367 0-.662-.313-.662-.703V9.84a.71.71 0 0 1 .334-.61l1.221-.744c.13-.079.21-.225.21-.383 0-.247-.188-.443-.416-.443H9.079a.22.22 0 0 0-.207.155l-.01.036c-.122.366-.503.556-.845.427s-.523-.533-.402-.896l.01-.035zm1.495 5.47c0-.25.093-.488.258-.663a.86.86 0 0 1 .624-.275c.234 0 .458.099.624.275a.97.97 0 0 1 .258.662.97.97 0 0 1-.258.663.86.86 0 0 1-.624.275.86.86 0 0 1-.624-.275.97.97 0 0 1-.258-.662"
    }, null, -1)
  ]))]))
}
export default { render: render }